import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import initApp from 'utils/functions/init';
import {
  addHoursToDateTime,
  addMonthsToDateTime,
  getDateObjWithoutTime,
} from 'utils/functions/dateTime';
import { contexts } from 'constants/contexts';
import { setContext } from 'modules/labs/common/actions';
import { fetchAllOrders } from 'modules/labs/orders/actions';
import OrdersView from 'modules/labs/orders/views/OrdersView';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const OrdersPage = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dispatch = useDispatch();

  const currentDate = getDateObjWithoutTime(new Date());
  const pastMonthDate = addMonthsToDateTime(getDateObjWithoutTime(new Date()), -2);

  const allOrdersApiCallBody = useMemo(
    () => ({
      orderBy: 'createdOn.desc',
      beginDate: addHoursToDateTime(pastMonthDate, 2),
      endDate: addHoursToDateTime(currentDate, 26),
    }),
    [currentDate, pastMonthDate],
  );
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  useEffect(() => {
    dispatch(setContext(contexts.orders));
    dispatch(fetchAllOrders(allOrdersApiCallBody));

    initApp(dispatch);
  }, [dispatch, allOrdersApiCallBody]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  const selectedDateRangeFilterObj = {
    startDate: pastMonthDate,
    endDate: currentDate,
  };

  return (
    <OrdersView
      allOrdersApiCallBody={allOrdersApiCallBody}
      selectedDateRangeFilterObj={selectedDateRangeFilterObj}
    />
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

OrdersPage.propTypes = {};

OrdersPage.defaultProps = {};

export default OrdersPage;
